import { QueryFeature } from '../../../config/queryClient';
import { UserActivitySortOrder } from '../UserActivity.meta';

enum QueryKey {
  ActivityLog = 'ActivityLog',
  ActivityFilter = 'ActivityFilter',
}

const concatIds = (ids: string[]) => (ids.length ? [...ids].sort().join(',') : '');

export const queryKeys = {
  activityLog: (
    clientId: string,
    hideAutomatic: boolean,
    sortOrder: UserActivitySortOrder,
    selectedActivityFilterIds: string[],
    selectedUserFilterIds: string[],
  ) => [
    QueryFeature.UserActivity,
    QueryKey.ActivityLog,
    clientId,
    hideAutomatic,
    sortOrder,
    concatIds(selectedActivityFilterIds),
    concatIds(selectedUserFilterIds),
  ],

  activityFilterOptions: (clientId: string, hideAutomatic: boolean) => [
    QueryFeature.UserActivity,
    QueryKey.ActivityFilter,
    clientId,
    hideAutomatic,
  ],

  activityLogsForClient: (clientId: string) => [
    QueryFeature.UserActivity,
    QueryKey.ActivityLog,
    clientId,
  ],
};
